import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const calendarApi = createApi({
  reducerPath: 'calendarApi',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_URL || '/api/v1',
    credentials: 'include',
  }),
  tagTypes: ['Slot'],
  endpoints: (builder) => ({
    listSlots: builder.query<any, string>({
      query: (tenantId) => `/calendar/${tenantId}/slots`,
      providesTags: ['Slot'],
    }),
    createSlot: builder.mutation<any, { tenantId: string; data: any }>({
      query: ({ tenantId, data }) => ({
        url: `/calendar/${tenantId}/slots`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Slot'],
    }),
    updateSlot: builder.mutation<any, { tenantId: string; slotId: string; data: any }>({
      query: ({ tenantId, slotId, data }) => ({
        url: `/calendar/${tenantId}/slots/${slotId}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Slot'],
    }),
  }),
});

export const { useListSlotsQuery, useCreateSlotMutation, useUpdateSlotMutation } = calendarApi;
